// extracted by mini-css-extract-plugin
export default {"complianceInfoModal":"Dc6rg3iVo5SB1ump8Etr","container":"YkTtDyhX9KRSjE9M2kwM"};